import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { returnIssuanceItems } from '../../../services/Inventory/IssuanceService';
import toast from 'react-hot-toast';

const ReturnIssuanceModal = ({ issuanceDetails, returnUnits, onClose }) => {
    const [issuedItemsList, setIssuedItemsList] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    
    const { returnedIssuedItemsList = [] } = issuanceDetails;
    
    useEffect(() => {
        if (issuanceDetails.issuedItemsList && issuanceDetails.issuedItemsList.length > 0) {
            const _issuedItemsList = issuanceDetails.issuedItemsList.map((item) => {
                const alreadyReturnedItem = returnedIssuedItemsList.find((val) => val.itemId === item.itemId);
                const alreadyReturnedItemStatus = returnUnits.find((val) => val.value === alreadyReturnedItem?.status);
                return {
                    ...item,
                    returnQty: alreadyReturnedItem ? alreadyReturnedItem?.returnQuantity : 0,
                    returnStatus: alreadyReturnedItemStatus ? alreadyReturnedItemStatus : null
                }
            })
            setIssuedItemsList(_issuedItemsList);
        }
    }, [issuanceDetails.issuedItemsList])

    const handleTextChange = (value, index) => {
        const numericValue = parseFloat(value) || 0;
        
        // Prevent negative values
        if (numericValue < 0) {
            return;
        }
        
        const updatedList = [...issuedItemsList];
        updatedList[index].returnQty = numericValue;
        setIssuedItemsList(updatedList);
        
        // Clear validation errors for this field when user makes changes
        if (validationErrors[`returnQty_${index}`] || validationErrors[`returnStatus_${index}`]) {
            const errors = { ...validationErrors };
            delete errors[`returnQty_${index}`];
            delete errors[`returnStatus_${index}`];
            setValidationErrors(errors);
        }
    }

    const handleSelect = (value, index) => {
        const updatedList = [...issuedItemsList];
        updatedList[index].returnStatus = value;
        setIssuedItemsList(updatedList);
        
        // Clear validation errors for this field when user makes changes
        if (validationErrors[`returnStatus_${index}`]) {
            const errors = { ...validationErrors };
            delete errors[`returnStatus_${index}`];
            setValidationErrors(errors);
        }
    }

    const validateAllItems = () => {
        let isValid = true;
        const errors = {};
        
        issuedItemsList.forEach((item, index) => {
            // Validate returnQty >= 0
            if (item.returnQty < 0) {
                errors[`returnQty_${index}`] = "Quantity cannot be less than zero";
                isValid = false;
            }
            
            // Validate returnStatus is required when returnQty > 0
            if (item.returnQty > 0 && !item.returnStatus) {
                errors[`returnStatus_${index}`] = "Return status is required when return quantity is greater than zero";
                isValid = false;
            }
        });
        
        setValidationErrors(errors);
        return isValid;
    };

    const submitReturnItems = () => {
        // Validate all items before submission
        if (!validateAllItems()) {
            toast.error("Please fix the validation errors before submitting");
            return;
        }
        
        const payload = issuedItemsList
            .filter((item) => item.returnQty > 0)
            .map((item) => ({
                itemId: item.itemId,
                issuanceCode: issuanceDetails?.issuanceCode,
                warehouseTitle: issuanceDetails?.warehouseTitle,
                returnQuantity: item.returnQty,
                issuedQuantityUnitTitle: item.issuedQuantityUnitTitle,
                status: item.returnStatus?.value
            }));
            
        if (payload.length === 0) {
            toast.error("Please add at least one item to return");
            return;
        }
            
        returnIssuanceItems(payload).then((res) => {
            if (res.errorCode === 0) {
                toast.success(res.message)
                onClose()
            } else {
                toast.error(res.message);
            }
        });
    }

    return (
        <div className='ember-view scroll-y noscroll-x fill body scrollbox'>
            <div id='scroll'>
                <div className='font-large text-uppercase font-xs text-open mb-2'>{issuanceDetails.issuanceCode}</div>
                <table className='customTable borderedTable'>
                    <tbody>
                        {issuanceDetails?.requisitionCode ? (
                            <tr>
                                <td className='font-large text-uppercase font-xs text-open'>{issuanceDetails?.requisitionCode}</td>
                            </tr>
                        ) : (
                            <></>
                        )}
                        {issuanceDetails.issuedToUserTitle ? (
                            <tr>
                                <td>Issued To:</td>
                                <td>{issuanceDetails.issuedToUserTitle}</td>
                            </tr>
                        ) : (
                            ''
                        )}
                        <tr>
                            <td>Issued By:</td>
                            <td>{issuanceDetails.issuedByUserTitle}</td>
                        </tr>
                        <tr>
                            <td>Issuance Date:</td>
                            <td>{issuanceDetails.issuanceDate}</td>
                        </tr>
                        <tr>
                            <td>Department:</td>
                            <td>{issuanceDetails.issuedDepartmentTitle}</td>
                        </tr>
                        <tr>
                            <td>Warehouse:</td>
                            <td>{issuanceDetails.warehouseTitle}</td>
                        </tr>
                        <tr>
                            <td>Note By Issuer:</td>
                            <td>{issuanceDetails.noteByIssue}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <hr />

            <div className='' id='scroll'>
                {issuedItemsList.length !== 0 ? (
                    <div>
                        <h3 className='font-size-16'>ISSUED ITEMS</h3>
                        <table className='customTable borderedTable'>
                            <thead>
                                <tr>
                                    <td>S No.</td>
                                    <td>Item</td>
                                    <td>SKU</td>
                                    <td>Qty</td>
                                    <td>Return Qty</td>
                                    <td>Return Unit</td>
                                </tr>
                            </thead>
                            <tbody>
                                {issuedItemsList.map((item, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{item.itemTitle}</td>
                                        <td>{item.itemSku}</td>
                                        <td>
                                            {item.issuedQuantity}&nbsp;
                                            {item.issuedQuantityUnitTitle}
                                        </td>
                                        <td>
                                            <div>
                                                <input
                                                    type='number'
                                                    min="0"
                                                    value={item.returnQty}
                                                    onChange={(e) => handleTextChange(e.target.value, i)}
                                                    style={{
                                                        borderColor: validationErrors[`returnQty_${i}`] ? 'red' : '',
                                                        width: '100%'
                                                    }}
                                                />
                                                {validationErrors[`returnQty_${i}`] && (
                                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>
                                                        {validationErrors[`returnQty_${i}`]}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <Select
                                                    options={returnUnits}
                                                    value={item.returnStatus}
                                                    onChange={(selectedOption) => handleSelect(selectedOption, i)}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            borderColor: validationErrors[`returnStatus_${i}`] ? 'red' : base.borderColor
                                                        })
                                                    }}
                                                />
                                                {validationErrors[`returnStatus_${i}`] && (
                                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>
                                                        {validationErrors[`returnStatus_${i}`]}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div>No issued items available.</div>
                )}
                <div id='ember3382' className='ember-view'></div>
            </div>
            <hr />

            <div className='d-flex justify-content-end' style={{ gap: '8px' }}>
                <button className='btn border' onClick={onClose}>Cancel</button>
                <button className='btn btn-primary' onClick={submitReturnItems}>Update</button>
            </div>
        </div>
    )
}

export default ReturnIssuanceModal